module.exports = __webpack_public_path__ + "img/b18d996.png";